// extracted by mini-css-extract-plugin
export var deliveryRow = "_ri-a";
export var fixedHeight = "_ri-4";
export var freightLogo = "_ri-9";
export var fullWidth = "_ri-3";
export var priceColumn = "_ri-5";
export var radioSelected = "_ri-7";
export var radioUnselected = "_ri-6";
export var selectedOption = "_ri-2";
export var selectedOptionContainer = "_ri-1";
export var selection = "_ri-0";
export var tallSkeletonText = "_ri-8";